import { render, staticRenderFns } from "./FieldInteger.vue?vue&type=template&id=623d5f1e&scoped=true"
import script from "./FieldInteger.vue?vue&type=script&lang=js"
export * from "./FieldInteger.vue?vue&type=script&lang=js"
import style0 from "./FieldInteger.vue?vue&type=style&index=0&id=623d5f1e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d5f1e",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
